// extracted by mini-css-extract-plugin
export default {"taskbar_main":"taskbar_taskbar_main__Gf9M2","taskbar_align":"taskbar_taskbar_align__Ze+Sp"};